import React from 'react';
import { PageSectionStacked, BaseProps } from '../page-section/PageSectionStacked';

interface ACTSectionProps {
    pageSection: BaseProps;
    subHeader: string;
}

interface FundamentalsProps {
    pageSection: BaseProps;
    subHeader: string;
}

interface CoursesThatFitProps {
    actSection: ACTSectionProps;
    fundamentals: FundamentalsProps;
}

const CoursesThatFit: React.FC<CoursesThatFitProps> = ({ actSection, fundamentals }) => {
    return (
        <>
            <div className="font-weight-light text-info text-center courses-that-fit-title py-5">
                Courses that fit your learning needs
            </div>
            <PageSectionStacked
                className="page-section-stacked bg-white py-0 text-center text-black"
                propsToRender={[
                    { ...actSection.pageSection, subHeader: actSection.subHeader },
                    { ...fundamentals.pageSection, subHeader: fundamentals.subHeader },
                ]}
                headerClassName="font-weight-bold mb-4 text-black"
                subHeaderClassName="font-weight-bold mb-3 text-black"
                contentClassName="font-weight-light text-center text-black"
                buttonPropOverrides={{ className: 'font-weight-bold mb-4' }}
            />
        </>
    );
};

export { CoursesThatFit, ACTSectionProps, FundamentalsProps, CoursesThatFitProps };
